import { InitFeatureParams } from '../types'
import { getRoutes } from './routes'

export const initAdmissions = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes())
}
